// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"2b3ad603b2b79bb32b3f","532":"a132e8fcfcbbd5df730e","678":"d866799b93ce629f8c90","883":"a7935f82552ddd8af39d"}[chunkId] + ".js";
};